import { get } from 'lodash-es';
import { isPartnerDealer } from 'site-modules/shared/utils/dealer-details-utils';

/**
 * Returns status of SpinCar 360
 * @param {object} vinData
 * @param {boolean} doNotSell
 * @param {boolean} isBLT2125DisableSpinCar360
 * @returns {boolean}
 */
export function isSpinCar360Enabled(vinData, doNotSell, isBLT2125DisableSpinCar360 = false) {
  const {
    hasExterior = false,
    hasInterior = false,
    extIntUrl = '',
  } = get(vinData, 'vehicleInfo.photo.photo360.SPINCAR', {});
  return (
    (hasExterior || hasInterior) && isPartnerDealer(vinData) && !doNotSell && !!extIntUrl && !isBLT2125DisableSpinCar360
  );
}
